import { render } from "./MapLegend.vue?vue&type=template&id=3c0825c9&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"

import "./MapLegend.vue?vue&type=style&index=0&id=3c0825c9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c0825c9"

export default script